import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import { PasswordInput, SimpleForm, Title, useNotify } from 'react-admin';
import { config } from '../config';
import { getJwtHeader } from '../auth/authProvider';

const validatePasswordChange = (values: any) => {
    const errors = {};
    if (values.password !== values.passwordAgain) {
        //@ts-ignore
        errors.passwordAgain = 'A két jelszó nem egyezik meg';
    }
    return errors;
};

const PasswordChangePage = () => {
    const notify = useNotify();
    return (
        <Card>
            <Title title="Jelszó változtatás" />
            <CardContent>
                <SimpleForm
                    validate={validatePasswordChange}
                    onSubmit={async (values) => {
                        await fetch(
                            `${config.apiUrl}/admin-user/change-password`,
                            {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: getJwtHeader(),
                                },
                                body: JSON.stringify({
                                    oldPassword: values.oldPassword,
                                    password: values.password,
                                }),
                            }
                        ).then(async (res) => {
                            if (!res.ok) {
                                await res.text().then((text) => {
                                    notify(text, { type: 'error' });
                                });
                            } else {
                                notify(`Sikeres jelszó változtatás!`, {
                                    type: 'success',
                                });
                            }
                        });
                    }}
                >
                    <PasswordInput
                        source="oldPassword"
                        label={'Jelenlegi jelszó'}
                        name={'oldPassword'}
                    />
                    <PasswordInput
                        source="password"
                        label={'Új jelszó'}
                        name={'password'}
                    />
                    <PasswordInput
                        source="passwordAgain"
                        label={'Új jelszó mégegyszer'}
                        name={'passwordAgain'}
                    />
                </SimpleForm>
            </CardContent>
        </Card>
    );
};

export default PasswordChangePage;
